import { h, Fragment } from "preact";
import {
  Alert,
  Box,
  Chip,
  CircularProgress,
  List,
  ListItemButton,
  Typography,
} from "@mui/material";
import { categoryLabel, formatDate, statusLabel, ticketContextLabel } from "../labels";

export function TicketList({ tickets, selectedId, loading, error, onSelect }) {
  if (loading) {
    return (
      <Box sx={{ py: 4, textAlign: "center" }}>
        <CircularProgress size={28} />
      </Box>
    );
  }

  if (error) return <Alert severity="error">{error}</Alert>;

  if (!tickets.length) {
    return (
      <Box sx={{ py: 4, px: 2, textAlign: "center" }}>
        <Typography color="text.secondary">Vous n’avez encore envoyé aucune demande.</Typography>
      </Box>
    );
  }

  return (
    <List disablePadding aria-label="Mes tickets de support" sx={{ bgcolor: "grey.50" }}>
      {tickets.map((ticket) => (
        <ListItemButton
          key={ticket.id}
          selected={ticket.id === selectedId}
          onClick={() => onSelect(ticket.id)}
          alignItems="flex-start"
          divider
          sx={{ py: 1.5 }}
        >
          <Box sx={{ width: "100%" }}>
            <Box sx={{ display: "flex", gap: 1, alignItems: "center", flexWrap: "wrap" }}>
              <Typography component="span" fontWeight={600}>
                {categoryLabel(ticket.category)}
              </Typography>
              <Chip
                label={statusLabel(ticket.status)}
                size="small"
                variant="outlined"
                sx={{ bgcolor: "background.paper" }}
              />
            </Box>

            <Box sx={{ mt: 2.5 }}>
              <Typography component="span" variant="caption" display="block">
                {ticket.reference}
                {` · ${ticketContextLabel(ticket)}`}
              </Typography>
              <Typography component="span" variant="caption" color="text.secondary">
                Mis à jour le {formatDate(ticket.last_activity_at)}
              </Typography>
            </Box>
          </Box>
        </ListItemButton>
      ))}
    </List>
  );
}
